
import {
  NumberFeature,
  StringFeature,
  Feature,
} from "@models";
import { 
  Spellbook,
  BonusSpells,
  SpellcastingFeature,
  CharacterFeature
} from "@dndModels";

export class CharacterSpellcasting {
  id: number;
  source_id: string;
  source_type: string;
  feature_type: string; 
  the_feature: Feature | null = null;

  constructor(obj?: any) {
    this.id = obj ? obj.id : 0;
    this.source_id = obj && obj.source_id ? obj.source_id : (obj ? obj.class_id : "");
    this.source_type = obj && obj.source_type ? obj.source_type : (obj && obj.class_id ? "Class" : "");
    this.feature_type = obj ? obj.feature_type : "";
    if (this.feature_type === "Spellbook") {
      // this.the_feature = obj ? new Spellbook(obj.the_feature) : new Spellbook();
    } else {
      this.the_feature = obj && obj.the_feature ? obj.the_feature : null;
    }
  }

  toDBObj(): any {
    let the_feature: any = null;
    if (this.feature_type === "Spellbook") {
      // the_feature = (this.the_feature as Spellbook).toDBObj();
    } else {
      the_feature = this.the_feature
    }
    return {
      id: this.id,
      source_id: this.source_id,
      source_type: this.source_type,
      feature_type: this.feature_type,
      the_feature
    };
  }

  copyFeature = (feature: CharacterFeature) => {
    if (feature.feature) {
      if ((feature.feature_type === "Spellbook" && feature.feature instanceof Spellbook) ||
        (feature.feature_type === "Bonus Spells" && feature.feature instanceof BonusSpells) ||
        (feature.feature_type === "Spellcasting" && feature.feature instanceof SpellcastingFeature) ||
        ((feature.feature_type === "Ritual Casting") && feature.feature instanceof StringFeature) ||
        ((feature.feature_type === "Cantrips" ||
          feature.feature_type === "Spells" ||
          feature.feature_type === "Mystic Arcanum" ||
          feature.feature_type === "Spell Mastery") && (feature.feature instanceof NumberFeature || feature.feature instanceof StringFeature))) {
        this.feature_type = feature.feature.feature_type;
        this.the_feature = feature.feature;
      }
    }
  }

  connectFeature = (feature: CharacterFeature) => {
    this.copyFeature(feature);
  }
}